module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-steak@2x-990c580cc0d8212ab90dd88ad35d4f89.png";